import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByIds } from '../../';
import { HorizontalRevenueChart } from './HorizontalRevenueChart';
import { useDashboardCardsRevenueChart, useProfile, useRouterStore } from '../../../hooks';
import { tI, tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CardsRevenue: React.FC = observer(() => {
    const data = useDashboardCardsRevenueChart();
    const routerStore = useRouterStore();
    const { isCompanyTypeIdMNOHost } = useProfile();
    const title = `${tP('Top Cards')} ${tI(isCompanyTypeIdMNOHost ? 'by Revenue' : 'by Cost/Revenue')}`;
    const goToCardList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('CardList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCardList} href={`/cards`}>
            {title}
        </a>
    );
    const goToCard = (id: string): void => {
        routerStore.goTo('Card', { params: { id } });
    };

    return (
        <Catcher>
            <LoadingApiByIds idSpinners={['GET_REVENUE_CARDS_LIST']} />
            <div className={Styles.chart}>
                <HorizontalRevenueChart
                    sourceData={data}
                    title={title}
                    titleLink={titleLink()}
                    onSelectRow={goToCard}
                />
            </div>
        </Catcher>
    );
});
